import { useNavigate } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { PageHeader, Button } from '@app-velocity/ui';

import { AuthStepper } from '../../ui/AuthStepper';
import { useRouterContext } from '../../router/useRouterContext';

export const AccountCreated = () => {
  const { strategy } = useRouterContext();
  const { t } = useI18n();
  const navigate = useNavigate();

  const goToHomePage = () => {
    navigate('/');
  };

  return (
    <>
      {strategy === 'WEB_APP' && <AuthStepper step="finish" />}
      <PageHeader>
        <PageHeader.Title>
          {t(
            strategy === 'WEB_APP'
              ? 'users:auth.account_created'
              : 'users:auth.account_created_plugin'
          )}
        </PageHeader.Title>
        <PageHeader.Subtitle>
          {t(
            strategy === 'WEB_APP'
              ? 'users:auth.account_created_description'
              : 'users:auth.account_created_description_plugin'
          )}
        </PageHeader.Subtitle>
      </PageHeader>
      <Button
        fullWidth
        type="submit"
        variant="contained"
        onClick={goToHomePage}
      >
        {t('users:auth.finish')}
      </Button>
    </>
  );
};
